import { UntitledIcon } from '@faceup/icons'
import { ulXClose } from '@faceup/icons/ulXClose'
import { Button } from '@faceup/ui-base'
import { defineMessages, useIntl } from '../TypedIntl'

const messages = defineMessages({
  close: 'FollowUp.closeIcon.tooltip.label',
})

type Props = {
  close: () => void
}

const Close = ({ close }: Props) => {
  const { formatMessage } = useIntl()
  return (
    <Button
      type='text'
      size='middle'
      icon={<UntitledIcon icon={ulXClose} className='text-colorIcon' size={28} />}
      label={formatMessage(messages.close)}
      onClick={() => close()}
    />
  )
}

export default Close
